import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowLeftRight } from "lucide-react";
import { useAuthStore } from "@/lib/auth/authStore";
import { HYBRID_BUSINESS_PATHS } from "@/app/layouts/sidebarNavConfig";

/**
 * Shfaqet vetëm kur: systemRole === 'clinician' && businessRole === 'owner'
 * Kushtetuta §V: Mos i përzier modalitetet klinike dhe të biznesit.
 */
export const HybridModeBanner = (): JSX.Element | null => {
  const systemRole  = useAuthStore((s) => s.systemRole);
  const businessRole= useAuthStore((s) => s.businessRole);
  const { pathname } = useLocation();
  const { t } = useTranslation();

  if (systemRole !== "clinician" || businessRole !== "owner") return null;

  const isBusinessMode = HYBRID_BUSINESS_PATHS.some(p => pathname.startsWith(p));

  return (
    <div className="flex items-center gap-3 border-b border-border bg-primary/5 px-4 py-2 text-xs">
      <ArrowLeftRight className="h-3.5 w-3.5 shrink-0 text-primary" aria-hidden="true" />
      <span className="font-semibold text-primary">
        {isBusinessMode ? t("access.businessMode") : t("access.clinicalMode")}
      </span>
      <span className="text-muted-foreground">·</span>
      <Link
        to={isBusinessMode ? "/app/professional" : "/app/business/manage"}
        className="font-medium text-primary transition hover:underline"
      >
        {isBusinessMode ? t("access.switchClinical") : t("access.switchBusiness")} →
      </Link>
    </div>
  );
};
